<template>
  <form>
    <b-modal
      v-model="show"
      title="Детальная информация"
      modal-class="spso-modal"
      hide-header-close
      hide-footer
      centered
      size="lg"
      @hide="hideModal"
    >
      <div class="v-application spso-modal__body pt-4 break-word">
        <vue-json-pretty
          v-if="detailInfo"
          :deep="2"
          show-length
          :select-on-click-node="false"
          :data="detailInfo"
        />
        <div
          v-else
          class="d-flex py-4"
        >
          <span class="mx-auto">{{ $t('common.no_data') }}</span>
        </div>
      </div>
      <div class="v-application d-flex mt-4 sticky-bottom">
        <v-btn
          color="primary"
          class="mr-4 flex-grow-1"
          outlined
          large
          @click="hideModal"
        >
          {{ $t('common.close') }}
        </v-btn>
      </div>
    </b-modal>
  </form>
</template>

<script>
import 'vue-json-pretty/lib/styles.css';

export default {
  name: 'DetailInfoModal',
  props: {
    value: Boolean,
    detailInfo: Object,
  },
  data: () => ({
    show: false,
  }),
  watch: {
    value(val) {
      this.show = val;
    },
  },
  methods: {
    hideModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.break-word {
  overflow-wrap: break-word;
}
</style>
